import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import snackbar from './plugins/Attachment/modules/snackbar';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    snackbar,
  },
  plugins: [createPersistedState()],
  state: {
    login: {
      token: '',
      accountToken: '',
      // user_id: null
      // app_id: '',
      // app_secret: ''
    },
    spinner: false,
    accounts: [],
    activeAccount: {},
    permissions: [],
    usersList: [],
    rolesList: [],
    resetPassword: false,
    occasionList: [],
    cardCategoriesList: [],
    cardsList: [],

    attachmentPopup: false,
    attachmentLocation: '',
    attachmentPopupData: [],
    giftCards: [],
    transactions: [],
    sendGiftsTransactions: [],

  },
  mutations: {
    SET_VUEX_STORAGE_TOKEN(state, data) {
      // eslint-disable-next-line
      state.login.token = data.token;
    },
    SET_VUEX_STORAGE_ACCOUNT_TOKEN(state, data) {
      // eslint-disable-next-line
      state.login.accountToken = data.account_token;
    },
    CLEAR_VUEX_STORAGE(state) {
      // eslint-disable-next-line
      state.login.token = '';
      // eslint-disable-next-line
      state.login.accountToken = '';
      // eslint-disable-next-line
      state.accounts = [];
      // eslint-disable-next-line
      state.activeAccount = {};
      // eslint-disable-next-line
      state.permissions = [];
      state.spinner = false;
    },
    SPINNER(state, data) {
      state.spinner = data;
    },
    ACCOUNTS(state, data) {
      // eslint-disable-next-line
      state.accounts = data;
      // test?
    },
    ACTIVE_ACCOUNT(state, data) {
      // eslint-disable-next-line
      state.activeAccount = data;
    },
    ACCOUNT_PERMISSIONS(state, data) {
      // eslint-disable-next-line
      state.permissions = data;
    },
    USERS_LIST(state, data) {
      // eslint-disable-next-line
      state.usersList = data;
    },
    ROLES_LIST(state, data) {
      // eslint-disable-next-line
      state.rolesList = data;
    },
    RESET_PASSWORD(state, data) {
      state.resetPassword = data.reset;
    },
    OCCASION_LIST(state, data) {
      // eslint-disable-next-line
      state.occasionList = data;
    },
    CARD_CATEGORIES_LIST(state, data) {
      // eslint-disable-next-line
      state.cardCategoriesList = data;
    },
    CARDS_LIST(state, data) {
      // eslint-disable-next-line
      state.cardsList = data;
    },
    ATTACHMENT_POPUP(state, data) {
      // eslint-disable-next-line
      state.attachmentPopup = data;
    },
    ATTACHMENT_POPUP_DATA(state, data) {
      // eslint-disable-next-line
      state.attachmentPopupData = data;
    },
    ATTACHMENT_LOCATION(state, data) {
      // eslint-disable-next-line
      state.attachmentLocation = data;
    },
    GIFT_CARDS(state, data) {
      // eslint-disable-next-line
      state.giftCards = data;
    },
    TRANSACTIONS(state, data) {
      // eslint-disable-next-line
      state.transactions = data;
    },
    SEND_GIFTS_TRANSACTIONS(state, data) {
      // eslint-disable-next-line
      state.sendGiftsTransactions = data;
    },
  },
  actions: {
    SET_SPINNER({ commit }, data) {
      commit('SPINNER', data);
    },
    SET_STORAGE_TOKEN({ commit }, data) {
      commit('SET_VUEX_STORAGE_TOKEN', data);
    },
    SET_STORAGE_ACCOUNT_TOKEN({ commit }, data) {
      commit('SET_VUEX_STORAGE_ACCOUNT_TOKEN', data);
    },
    CLEAR_STORAGE({ commit }) {
      commit('CLEAR_VUEX_STORAGE');
    },
    SET_ACCOUNTS({ commit }, data) {
      commit('ACCOUNTS', data);
    },
    SET_ACTIVE_ACCOUNT({ commit }, data) {
      commit('ACTIVE_ACCOUNT', data);
    },
    SET_ACCOUNT_PERMISSIONS({ commit }, data) {
      commit('ACCOUNT_PERMISSIONS', data);
    },
    SET_USERS_LIST({ commit }, data) {
      commit('USERS_LIST', data);
    },
    SET_ROLES_LIST({ commit }, data) {
      commit('ROLES_LIST', data);
    },
    SET_RESET_PASSWORD({ commit }, data) {
      commit('RESET_PASSWORD', data);
    },
    SET_OCCASION_LIST({ commit }, data) {
      commit('OCCASION_LIST', data);
    },
    SET_CARD_CATEGORIES_LIST({ commit }, data) {
      commit('CARD_CATEGORIES_LIST', data);
    },
    SET_CARDS_LIST({ commit }, data) {
      commit('CARDS_LIST', data);
    },
    SET_ATTACHMENT_POPUP({ commit }, data) {
      commit('ATTACHMENT_POPUP', data);
    },
    SET_ATTACHMENT_POPUP_DATA({ commit }, data) {
      commit('ATTACHMENT_POPUP_DATA', data);
    },
    SET_ATTACHMENT_LOCATION({ commit }, data) {
      commit('ATTACHMENT_LOCATION', data);
    },
    SET_GIFT_CARDS({ commit }, data) {
      commit('GIFT_CARDS', data);
    },
    SET_TRANSACTIONS({ commit }, data) {
      commit('TRANSACTIONS', data);
    },
    SET_SEND_GIFTS_TRANSACTIONS({ commit }, data) {
      commit('SEND_GIFTS_TRANSACTIONS', data);
    },

  },
  getters: {
    getSpinner(state) {
      return state.spinner;
    },
    getToken(state) {
      return state.login.token;
    },
    getAccountToken(state) {
      return state.login.accountToken;
    },
    getAccounts(state) {
      return state.accounts;
    },
    getActiveAccount(state) {
      return state.activeAccount;
    },
    getLoggedInUserSelectedBusinessId(state) {
      return state.activeAccount.business_id;
    },
    getAccountPermissions(state) {
      return state.permissions;
    },
    getUsers(state) {
      return state.usersList;
    },
    getRoles(state) {
      return state.rolesList;
    },
    getResetPassword(state) {
      return state.resetPassword;
    },
    getOccasions(state) {
      return state.occasionList;
    },
    getCardCategoriesList(state) {
      return state.cardCategoriesList;
    },
    getCardsList(state) {
      return state.cardsList;
    },
    getAttachmentPopup(state) {
      return state.attachmentPopup;
    },
    getAttachmentPopupData(state) {
      return state.attachmentPopupData;
    },
    getAttachmentLocation(state) {
      return state.attachmentLocation;
    },
    getGiftCards(state) {
      return state.giftCards;
    },
    getTransactions(state) {
      return state.transactions;
    },
    getSendGiftsTransactions(state) {
      return state.sendGiftsTransactions;
    },
  },
});
